export const Prompt = ' How would you rate this chat experience?';

/**
 * Options available for customers to rate their chat experience.
 * NOTE: The order of the properties determines the order they are rendered.
 */
export const SATISFACTION_RATING_OPTIONS = {
  POOR: 'poor',
  AVERAGE: 'average',
  GREAT: 'great',
} as const;

export const TWILIO_RATING_TYPES = {
  AI_SURVEY: 'ai_survey',
} as const;
